import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './ProgressDashboard.scss';

class ProgressDashboard extends Component {
  static defaultProps = {
    usedNumber: 1,
    limitNumber: 5
  };

  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  render() {
    const { className = '', usedNumber, limitNumber } = this.props;
    if (!limitNumber) {
      return (<div></div>);
    }
    const progressWidth = (usedNumber / limitNumber) * 100;
    const message = `${usedNumber}/${limitNumber} in use`;
    return (
      <div className={`progress-dashboard ${className} ${usedNumber === limitNumber ? 'progress-dashboard-unlimit' : ''}`}>
        <div className="progress-inner" style={{width: progressWidth + "%"}}></div>
        <span>{message}</span>
      </div>
    );
  }
}

ProgressDashboard.propTypes = {
  className: PropTypes.string,
  usedNumber: PropTypes.number,
  limitNumber: PropTypes.number
};

export default ProgressDashboard;
